<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Page Not Found</h1>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
export default {
  name: 'NotFound',
  components: {
    CardComponent
  }
}
</script>
